export default __webpack_public_path__ + "static/media/cursos-imagem.8d253bdc.svg";